<template>
  <div class="page">
    <div class="title">{{title}}</div>
    <div class="select">
      <el-select v-model="pageCount" :size="size" @change="pageChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="title title2">Go to Page</div>
    <div class="select">
      <el-select
        :size="size"
        v-model="pageNo"
        filterable
        allow-create
        default-first-option
        @change="pageChange"
      >
        <el-option
          v-for="item in pageSize"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    total: Number,
    size: {
      type: String,
      default: "medium",
    },
    title:{
      type:[Boolean,String],
      default:'No. of Order Per Page'
    }
  },
  data() {
    return {
      options: [
        {
          value: "10",
          label: "10",
        },
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        },
        {
          value: "100",
          label: "100",
        },
      ],
      pageCount: "10",
      pageSize: [],
      pageNo: 1,
    };
  },
  watch: {
    total: {
      handler() {
        this.setPageSize();
      },
    },
  },
  methods: {
    pageChange() {
      this.$emit("pageChange", {
        pageNo: this.pageNo,
        pageSize: this.pageCount,
      });
      this.setPageSize();
    },
    setPageSize() {
      let pageLength = Math.ceil(this.total / this.pageCount);
      if (pageLength == 0) {
        pageLength = 1;
      }
      let pageSize = [];
      for (let i = 0; i < pageLength; i++) {
        pageSize.push({
          value: i + 1,
          label: i + 1,
        });
      }
      this.pageSize = pageSize;
    },
    init() {
      this.pageNo = 1;
      this.pageCount = 10;
    },
  },
};
</script>
<style scoped>
.page {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.select {
  max-width: 80px;
}
.title {
  margin-right: 20px;
}
.title2 {
  margin-left: 100px;
}
</style>